import './modal.scss';
import './modal.twig';

const containerShowClass = 'modal-container--show';

const modalSelector = '.modal';
const contentSelector = '.modal__content';

const containerSelector = '.modal-container';
const containerCloseSelector = '.modal-container__close';
const containerContentSelector = '.modal-container__content';
const containerDialogSelector = '.modal-container__dialog';

const bodyAppend = document.createElement('div');
bodyAppend.innerHTML =
  '<div class="modal-container"><div class="modal-container__dialog"><div class="modal-container__close-wrapper"><button class="modal-container__close">×</button></div><div class="modal-container__content"></div></div></div>';
const modalContainer = bodyAppend.querySelector(containerSelector);
const modalContainerClose = modalContainer.querySelector(
  containerCloseSelector
);
const modalContainerContent = modalContainer.querySelector(
  containerContentSelector
);
const modalContainerDialog = modalContainer.querySelector(
  containerDialogSelector
);
document.body.appendChild(modalContainer);

/**
 * @type {Node|undefined}
 */
let currentContainer = undefined;

/**
 * @param {Node} container
 */
function open(container) {
  currentContainer = container;
  while (currentContainer.childNodes.length) {
    modalContainerContent.appendChild(currentContainer.childNodes[0]);
  }
  modalContainer.classList.add(containerShowClass);
  modalContainerContent.focus();
}

function close() {
  modalContainer.classList.remove(containerShowClass);
  if (currentContainer) {
    while (modalContainerContent.childNodes.length) {
      currentContainer.appendChild(modalContainerContent.childNodes[0]);
    }
  } else {
    modalContainerContent.innerHTML = '';
  }
}

modalContainerClose.addEventListener('click', () => {
  close();
});

modalContainer.addEventListener('click', () => {
  if (
    modalContainerDialog !== event.target &&
    !modalContainerDialog.contains(event.target)
  ) {
    close();
  }
});

/**
 * @param {Document | HTMLElement} context
 */
export function enable(context) {
  context.querySelectorAll(modalSelector).forEach((modal) => {
    const { triggerId } = modal.dataset;
    const trigger = document.getElementById(triggerId);
    const content = modal.querySelector(contentSelector);

    trigger.addEventListener('click', () => {
      open(content);
    });
  });
}

export default enable;
